module.exports = __webpack_public_path__ + "static/logo-paramount-f1e69fefb078980ed25db8ff3d29f6bd.svg";